import { JsonApiModelConfig } from '@elearnio/angular2-jsonapi';
import { Member } from '../member.model';

@JsonApiModelConfig({
  type: 'members',
  modelEndpointUrl: 'members/assignees',
})
export class MemberIdentifier extends Member {}
